import {
  BaseAddressSchema,
  IntegrationsSchema,
} from "@redotech/redo-return-core-common/address-collection";
import * as z from "zod";

export const createAddress = {
  name: "createAddress" as const,
  input: z.object({
    address: BaseAddressSchema,
    integrations: IntegrationsSchema.optional(),
  }),
  output: z.object({ addressId: z.string() }),
};
